import { render, staticRenderFns } from "./StudioVideos.vue?vue&type=template&id=9f830dfa&"
import script from "./StudioVideos.vue?vue&type=script&lang=js&"
export * from "./StudioVideos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports